export const packageNames = [
  'kolay',
];

export const loadApiDocs = {
  'kolay': () => fetch('/docs/kolay.json'),
};